<template>
  <div
    id="promotion-insert"
    class="container-fluid background-white"
    :class="{ active: promotion.active && storePromotions.length > 0 }"
  >
    <!-- Add Dynamic CSS Class to Hide This Entire Section If Promotion Data Not Available -->
    <div class="container" v-if="storePromotions.length > 0">
      <div class="row">
        <div class="col-md-12">
          <h2 class="w-100 text-center">{{ promotion.name }}</h2>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <CouponCarousel
            :coupons="storePromotions"
            @couponClicked="setActiveSlide"
            @triggerModal="triggerModal"
          ></CouponCarousel>
        </div>
      </div>
    </div>
    <StorePromoModal
      ref="promotionModal"
      :promotion="promotion"
      :slide="selectedCoupon"
      v-if="formType !== 'ppc'"
      @toggleQuote="triggerQuote"
      @toggleAppointment="triggerAppointment"
    ></StorePromoModal>
    <StorePromoPpcModal
      :promotion="promotion"
      :slide="selectedCoupon"
      v-if="formType == 'ppc'"
    ></StorePromoPpcModal>
  </div>
</template>
<!-- @TODO - May need to split functionality here as PPC doesn't technically support Vue Bootstrap -->
<script>
import StorePromoModal from "@/components/partials/StorePromoModal.vue";
import StorePromoPpcModal from "@/components/partials/StorePromoPpcModal.vue";
import CouponCarousel from "@/components/partials/CouponCarousel.vue";
export default {
  name: "StorePromo",
  components: {
    StorePromoModal,
    CouponCarousel,
    StorePromoPpcModal,
  },
  data: () => {
    return {
      currentSlide: 0,
      store_id: null,
    };
  },
  props: {
    formType: String,
  },
  created() {
    // Let's Attempt to Make This Usable for PPC and Store Landing Page
    if (this.formType == "ppc") {
      if (window.$storeID) {
        this.store_id = window.$storeID;
        this.$store.dispatch("loadStorePromos", this.store_id);
      }
    } else {
      // @TODO - Store Promo is set to dispatch / update promos on every page load (which is probably ideal)
      if (window.$storeID) {
        this.store_id = window.$storeID;
        this.$store.dispatch("loadStorePromos", this.store_id);
      }
    }
  },
  mounted: function () {},
  computed: {
    storePromotions() {
      return this.$store.state.promotion.coupon_stores;
    },
    promotion() {
      return this.$store.state.promotion;
    },
    selectedCoupon() {
      return this.currentSlide;
    },
  },
  methods: {
    setActiveSlide(index) {
      this.currentSlide = parseInt(index);
      this.triggerModal();
    },
    triggerModal() {
      if (this.formType == "ppc") {
        this.$bvModal.show("store-promo-modal-ppc");
      } else {
        this.$bvModal.show("store-promo-modal");
      }
    },
    triggerQuote() {
      window.tintworldVue.$root.$store.commit("OpenModal", "quote");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
    },
    triggerAppointment() {
      window.tintworldVue.$root.$store.commit("OpenModal", "appointment");
      window.tintworldVue.$root.$emit("bv::show::modal", "tint-world-modal");
    },
  },
};
</script>

<style scoped>
.coupon-image:hover {
  cursor: pointer;
}
#promotion-insert {
  display: none;
}

#promotion-insert.active {
  display: block;
  padding-top: 25px;
  padding-bottom: 25px;
  background-color: #b9b9b9;
}
.btn-tint-world-outline {
  border-color: black;
  color: black;
  font-weight: bold;
  border-width: 2px;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  text-transform: uppercase;
}
.btn-tint-world-outline:hover,
.btn-tint-world-outline:focus,
.btn-tint-world-outline:active {
  background: #fe0 !important;
  color: black !important;
}
.btn-tint-world {
  background: #fe0;
  -webkit-transition: all 0.3s ease-out;
  -o-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
  color: black;
  font-weight: bold;
  text-transform: uppercase;
  border-color: black;
  border-radius: 0px;
}
.btn-tint-world:hover,
.btn-tint-world:focus,
.btn-tint-world:active,
.btn-tint-world.active-item {
  background: #000;
  background-color: #000 !important;
  border-color: black;
  color: white !important;
}
.accordion-top-copy {
  background: #ecececec;
  border-radius: 0px;
  border-bottom: solid 2px black;
}
.ppf-copy-container {
  background-color: #ecececec;
}
.ppf-description {
  color: black;
  font-size: 15px;
  text-align: center;
}
.accordion-top-copy {
  font-size: 18px;
}
.vehicle-image-wrapper {
  width: 100%;
  padding-top: 72.5%;
  position: relative;
}
img.vehicle-image {
  position: absolute;
  top: 0;
  left: 0;
}
@media (min-width: 1025px) {
  .vehicle-icon {
    max-width: 20%;
  }
}
@media (max-width: 1024px) {
  .vehicle-icon {
    max-width: 20%;
  }
}
@media (min-width: 992px) {
  .mobile-package-list {
    display: none;
  }
  .nobreak {
    white-space: nowrap;
  }
  .ppf-options-headline {
    font-size: 22px;
  }
  .accordion-top-copy .card-body {
    padding: 15px;
  }
  .accordion-top-copy p {
    line-height: normal;
  }
}
@media (max-width: 991px) {
  .desktop-package-list {
    display: none;
  }
  #ppf h3 {
    font-size: 1.5rem;
  }
  .vehicle-image-wrapper {
    overflow: hidden;
  }
}
.mobile-ppf-description {
  font-size: 14px;
  min-height: 100px;
}
.row.bg-yellow {
  background: #fe0;
  margin-bottom: 15px;
}
.ppf-header-headline {
  font-size: 1rem;
  margin-top: 5px;
  margin-bottom: 5px;
}
.ppf-header-subline {
  font-size: 1rem;
  margin-top: 5px;
  margin-bottom: 5px;
}
.bg-dark-gray {
  background-color: #ecececec;
}
a.icon {
  color: black;
  font-weight: bold;
  cursor: pointer;
}
.accordion-section-title {
  text-align: center;
  text-transform: uppercase;
  font-weight: bold;
  background: #666;
  color: white !important;
  border-radius: 0px;
  padding: 10px;
}
</style>
